import Leonora1 from '../Leonora/Leonora.webp'
import Leonora2 from '../Leonora/Leonora (2).webp'
import Leonora3 from '../Leonora/Leonora (3).webp'
import Leonora4 from '../Leonora/Leonora (4).webp'
import Leonora5 from '../Leonora/Leonora (5).webp'
import Leonora6 from '../Leonora/Leonora (6).webp'
import Leonora7 from '../Leonora/Leonora (7).webp'



const Leonoraimages =[
Leonora1,Leonora2,Leonora3,Leonora4,Leonora5,Leonora6,Leonora7
]

export default Leonoraimages;